import { Link } from "react-router-dom";

interface WordmarkProps {
  size?: number;
}

/**
 * Editorial BRICK. wordmark — Switzer Black (900), terracotta period.
 * Single-family system: same font as display + body, weight 900 for the mark.
 */
export const Wordmark = ({ size = 22 }: WordmarkProps) => {
  const fontStyle = {
    fontFamily: "'Switzer-Variable', 'Switzer', ui-sans-serif, system-ui, sans-serif",
    fontWeight: 900,
    fontSize: size,
    letterSpacing: "-0.035em",
    lineHeight: 1,
  } as const;

  return (
    <Link
      to="/"
      className="group inline-flex items-baseline no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--accent-brick))] focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(var(--bg-canvas))] rounded-sm"
      aria-label="BRICK. — home"
    >
      <span
        className="text-[hsl(var(--fg-cream))] transition-opacity group-hover:opacity-90"
        style={fontStyle}
      >
        BRICK
      </span>
      <span className="text-[hsl(var(--accent-brick))]" style={fontStyle}>
        .
      </span>
    </Link>
  );
};
